module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/1-d258dce2874e9e7485b16c121d3d5909.webp";